import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";
import { partners } from "@/mocks/partners";

export default function PartnersStrip() {
  return (
    <section className="w-full bg-background-100 pb-16 pt-8 md:pb-24 md:pt-10">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <SectionHeading
            align="center"
            eyebrow="Three Companies. One EV Vision."
            title="Three Technology Strengths. One Electric Future."
            description="KAL LORDS ZERO21 DJT brings together three technology partners whose strengths complement each other across retrofit experience, EV engineering and charging infrastructure. This is a technology collaboration, not a claim of a merged entity."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {partners.map((partner, index) => (
            <Reveal key={partner.key} delay={index * 0.1}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors duration-300 hover:border-primary-300 md:p-7">
                <div className="flex h-16 w-full items-center justify-start">
                  <div className="h-14 w-auto max-w-[180px]">
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      title={`${partner.name} - EV retrofit technology partner`}
                      className="h-full w-auto object-contain object-left"
                    />
                  </div>
                </div>
                <h3 className="mt-5 text-xl font-bold text-foreground-950">{partner.name}</h3>
                <p className="mt-1 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-700">
                  {partner.tagline}
                </p>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">
                  {partner.overview}
                </p>
                <ul className="mt-5 space-y-2 border-t border-background-200 pt-5">
                  {partner.capabilities.map((cap) => (
                    <li key={cap} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-primary-600" />
                      {cap}
                    </li>
                  ))}
                </ul>
                <a
                  href={partner.website}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="mt-6 inline-flex cursor-pointer items-center gap-2 font-label text-sm font-semibold text-foreground-900 hover:text-primary-700"
                >
                  Visit Website <i className="ri-external-link-line" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-10 flex justify-center">
            <ActionButton to="/partners" variant="outline" size="md" iconRight="ri-arrow-right-line">
              Explore Partner Profiles
            </ActionButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}